import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import axios from "axios";
import ReligiousAffiliationTable from "../../../components/tables/ReligiousAffiliationTable";

export default function ReligiousAffiliations() {
  const { t } = useContext(TranslatorContext);

  const [affiliations, setAffiliations] = useState([]);
  const [allAffiliations, setAllAffiliations] = useState([]);

  const [search, setSearch] = useState("");
  const [faithFilter, setFaithFilter] = useState("");
  const [placeFilter, setPlaceFilter] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");

  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchAffiliations();
  }, []);

  const fetchAffiliations = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/religious-affiliations"
      );

      const mappedData = res.data.affiliations.map((item) => ({
        id: item.id,

        person_id: item.person_id,

        f_number: item.person?.f_number,

        beneficiary_name: item.person?.beneficiary_name,



        faith_name: item.place?.faith?.name ?? "-",

        prayer_place: item.place?.palace_name ?? "-",

        address: item.person?.present_address ?? "-",





        action: {
          edit: "edit",
          delete: "delete",
        },
      }));

      setAffiliations(mappedData);
      setAllAffiliations(mappedData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let filtered = [...allAffiliations];

    // Search
    if (search) {
      const searchValue = search.toLowerCase();

      filtered = filtered.filter(
        (item) =>
          item.person_name?.toLowerCase().includes(searchValue) ||
          item.beneficiary_name?.toLowerCase().includes(searchValue) ||
          item.f_number?.toLowerCase().includes(searchValue)
      );
    }

    // Faith Filter
    if (faithFilter) {
      filtered = filtered.filter(
        (item) => item.faith_name === faithFilter
      );
    }

    // Prayer Place Filter
    if (placeFilter) {
      filtered = filtered.filter(
        (item) => item.prayer_place === placeFilter
      );
    }

    setAffiliations(filtered);
  }, [
    search,
    faithFilter,
    placeFilter,
    allAffiliations,
  ]);

  const faiths = [
    ...new Set(
      allAffiliations
        .map((item) => item.faith_name)
        .filter(Boolean)
    ),
  ];

  const prayerPlaces = [
    ...new Set(
      allAffiliations
        .map((item) => item.prayer_place)
        .filter(Boolean)
    ),
  ];

  const resetFilters = () => {
    setSearch("");
    setFaithFilter("");
    setPlaceFilter("");
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                Religious Affiliation ({affiliations.length})
              </h3>

              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    Home
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">
                  Religious Affiliation
                </li>

                <li className="mc-breadcrumb-item">
                  All Religious Affiliation
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">

        <Col xl={12}>
          <div className="mc-card">

            {/* Filters */}
            <Row className="mb-4">
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Search Family / Person"
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                />
              </Col>

              <Col md={3}>
                <Form.Select
                  value={faithFilter}
                  onChange={(e) =>
                    setFaithFilter(e.target.value)
                  }
                >
                  <option value="">All Faiths</option>

                  {faiths.map((faith, index) => (
                    <option key={index} value={faith}>
                      {faith}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Select
                  value={placeFilter}
                  onChange={(e) =>
                    setPlaceFilter(e.target.value)
                  }
                >
                  <option value="">
                    All Prayer Places
                  </option>

                  {prayerPlaces.map((place, index) => (
                    <option key={index} value={place}>
                      {place}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={2}>
                <Button
                  variant="secondary"
                  className="w-100"
                  onClick={resetFilters}
                >
                  Reset
                </Button>
              </Col>
            </Row>

            {/* Table */}
            <Row>
              <Col xl={12}>
                <ReligiousAffiliationTable
                  thead={[
                    "Sr. No",
                    "FSF-ID",
                    "Person Name",

                    "Faith",
                    "Prayer Place",

                    "Actions",
                  ]}
                  tbody={affiliations}
                />
              </Col>
            </Row>

          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}